import { Hourglass } from "components/icons/generated";
import ListBox from "components/listBox/index";
import ListBoxInfoWrapper from "components/listBox/InfoWrapper";
import ListBoxItem from "components/listBox/Item";
import TriggeredByFlows from "components/TriggeredByFlows";
import { VcsProvider } from "types/generated";
import { getCommitLabel } from "utils/commit";
import Timestamp from "components/Timestamp";
import { AccessResult } from "utils/access";
import { isFlowsTrigger } from "utils/flows";
import { providerHasVcsHost } from "utils/vcs";

type TaskElementProps = {
  id: string;
  canPerformAgain: AccessResult;
  command: string;
  commit: {
    hash: string;
    url: string;
  };
  createdAt: number;
  stackId: string;
  state: string;
  triggeredBy: string;
  provider: VcsProvider;
};

const TaskElement = (props: TaskElementProps) => {
  const { stackId, command, provider } = props;

  const triggeredBy = isFlowsTrigger(props.triggeredBy) ? (
    <TriggeredByFlows triggeredBy={props.triggeredBy} />
  ) : (
    props.triggeredBy
  );

  const hasVcsHost = providerHasVcsHost(provider);
  const commitLabel = getCommitLabel(provider, props.commit.hash);

  return (
    <ListBox
      headerLink={{
        name: command,
        to: `/stack/${stackId}/run/${props.id}`,
        routerLink: true,
        renderAsCode: true,
        canCopyName: true,
      }}
      performAgainErrorMessage={props.canPerformAgain.message}
      performAgain={props.canPerformAgain.result ? { stackId, command } : undefined}
      state={{ content: props.state, showTitle: true }}
    >
      <ListBoxInfoWrapper>
        <ListBoxItem icon={Hourglass}>
          Started on <Timestamp timestamp={props.createdAt} /> by {triggeredBy}
        </ListBoxItem>
        {!hasVcsHost && <ListBoxItem>{commitLabel}</ListBoxItem>}
        {hasVcsHost && (
          <ListBoxItem
            link={{
              url: props.commit.url,
              text: commitLabel,
            }}
          />
        )}
      </ListBoxInfoWrapper>
    </ListBox>
  );
};

export default TaskElement;
